export default __webpack_public_path__ + "static/media/paramount-logo-white.22c5703a.png";